import register       from '../../register.js';
import $              from 'jquery';
import FormSequence   from '../classes/form-sequence';

import schedule       from '../steps/schedule-install-fsl/step';
import stepNumbers    from '../templates/components/step-numbers.hbs';
import signupTemplate from '../templates/signup-sequence.hbs';
import footerTemplate from '../templates/components/footer.hbs';

export default register( 'blackouts', () => {

  const footerMarkup  = footerTemplate();

  const sequence = new FormSequence({
    $el: $('.signup-container'),
    first: 'schedule_install',
    template: signupTemplate,
    events: {},
    configs: {
      schedule_install: {
        step: schedule,
        next: null,
        description: stepNumbers({ active: 1, num_steps: 1 }),
        footer: footerMarkup
      }
    }
  });

  window.sequence = sequence;
});
